import {Environment, Team} from '@eitje/api'
import {useShared} from '../../use_shared'
import {useFilterCache} from '../hooks'
import _ from 'lodash'

export const getFirmRecordsAndIds = ({taxonomies, name, orgCacheKey}) => {
	const tax = filterName => taxonomies.find(t => t.filterName == filterName)
	const envAndTeam = tax('environment_and_team')
	const env = tax('environment')
	const team = tax('team')

	// Filter teams and environments on the current org. We have both teams and environments from different orgs,
	// in order to show env names in the env switch and show team names in chat.
	const {organisation, myEnvs} = useShared()

	const cache = filterName => {
		const cacheValue = useFilterCache({name, orgCacheKey, filterName})
		const listPickerOptions = tax(filterName)?.items._map('id')

		// If no IDs are stored in Redux, that effectively means that all options are selected.
		return _.isEmpty(cacheValue) ? listPickerOptions : cacheValue
	}

	const envAndTeamCache = cache('environment_and_team')
	const envCache = cache('environment')
	const teamCache = cache('team')

	let teamIds
	if (team) {
		teamIds = teamCache
	} else if (envAndTeam) {
		teamIds = envAndTeamCache
	} else {
		teamIds = []
	}
	teamIds = teamIds.uniq().sort()
	const teams = Team.useWhere({id: teamIds, environment_id: myEnvs._map('id')})
	teamIds = teams._map('id').sort() // filter on current org

	let envIds
	if (env) {
		envIds = envCache
		// "envAndTeam" can spawn "team" filter insted in single env org
	} else if (envAndTeam || team) {
		envIds = teams._map('environment_id')
	} else {
		envIds = []
	}
	envIds = envIds.uniq().sort()
	const environments = Environment.useWhere({id: envIds, organisation_id: organisation.id})
	envIds = environments._map('id').sort() // filter on current org

	return {
		environmentIds: envIds,
		environments,
		teamIds,
		teams,
	}
}
